import { EvaluationReport } from '@spike/report-model';
import styles from './EvaluationResult.module.scss';

import { faScissors, faBan, faHotel } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { FunctionComponent } from 'react';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface EvaluationResultProps {
    evaluationReport: EvaluationReport;
}

const FINAL_RESULTS_CONFIG: {
    key: keyof EvaluationReport;
    label: string;
    icon: any;
}[] = [
    { key: 'finalResultGrooming', label: 'Grooming', icon: faScissors },
    { key: 'finalResultDaycare', label: 'Daycare', icon: faBan },
    { key: 'finalResultBoarding', label: 'Boarding', icon: faHotel }
];

export const EvaluationResult: FunctionComponent<EvaluationResultProps> = ({ evaluationReport }) => {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <Label className={styles.sectionLabel}>Final Results</Label>
            </div>
            <div className={styles.results}>
                {FINAL_RESULTS_CONFIG.map(({ key, label, icon }) => {
                    const resultValue = evaluationReport[key];
                    const resultIcon =
                        resultValue === 'pass' ? faCircleCheck : resultValue === 'fail' ? faCircleXmark : faCircleXmark;

                    const resultClass =
                        resultValue === 'pass' ? styles.pass : resultValue === 'fail' ? styles.fail : styles.unknown;

                    return (
                        <div
                            key={key}
                            className={styles.resultItem}
                        >
                            <div className={styles.resultInfo}>
                                <FontAwesomeIcon
                                    icon={icon}
                                    size="sm"
                                    className={styles.icon}
                                />
                                <Label className={styles.resultLabel}>{label}</Label>
                            </div>
                            <FontAwesomeIcon
                                icon={resultIcon}
                                size="lg"
                                className={`${styles.resultIcon} ${resultClass}`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
